import CaseFilter from '../statistics';
import CaseVolume from '../caseVolumeLineChart';
import CustomPieChart from '../customPieChart';
import CustomComponentAreaCaseBySubmission from '../customComponentAreaCaseBySubmission';
import GeographicalStatistics from '../geographicalStatistics';
import { FC, useContext } from 'react';
import { GeographicalStatisticsObject } from 'src/pages/manufacturer/types';
import AuthMaunfacturerSubHeader from '../authManufacturerSubHeader';
import { AllProductProps } from '../allProductsStats/types';
import CustomComponentForPriorAuth from '../customComponentPriorAuth';
import FooterText from 'src/components/footerText';
import { AuthContext } from 'src/context/authContext';
import DrillDownPieChart from '../drillDownPieChart';

const AllproductsAreaManager: FC<AllProductProps> = ({ statisticsData, queryParams, updateQueryParamsAndCallAPI, getStatisticsData, drug }): JSX.Element => {

  const { userData } = useContext(AuthContext);

  return (
    <div
      className={`overflow-y-auto ${drug === "iovera" ? 'iovera-content' : drug === "zilretta" ? 'zilretta-content' : ''}`}
      style={{ backgroundColor: '#cdedfa' }}>
      <div className="container " >
        <AuthMaunfacturerSubHeader />
        {statisticsData && userData && (
          <CaseFilter
            defaultQueryParams={queryParams}
            updateQueryParams={updateQueryParamsAndCallAPI}
            title={`${userData?.name} Statistics`}
          />
        )}
        {statisticsData && queryParams && (
          <CaseVolume startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData} buttonShows={true} drug={drug} />
        )}
        {statisticsData && (
          <CustomPieChart pieChartObject={statisticsData.data.top_payors} title="Top 10 Payors" />
        )}
        <div>
          {statisticsData && statisticsData.data &&
            <CustomPieChart title="Top 10 Payor Types" pieChartObject={statisticsData.data.top_payer_types} />
          }
        </div>
        <div className='row'>
          <div className='col'>
            {statisticsData && statisticsData.data &&
              <DrillDownPieChart pieChartObject={statisticsData.data.icd_data} title={'Top 10 ICD Codes'} />}
          </div>
        </div>

        {statisticsData && (
          <div className="row">
            <div className="col-12">
              <div className="card mt-3">
                <div className="card-header">
                  <h5 className="m-0 text-center text-primary">Transfers (vs previous year)
                  </h5>
                </div>
                <div className="card-body">
                  <h6 className="text-center">
                    {statisticsData.data.transfers_vs_previous_year}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        )}

        {statisticsData && queryParams && (
          <CustomComponentForPriorAuth startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} drug={''} />
        )}

        {statisticsData && queryParams && (
          <CustomComponentAreaCaseBySubmission startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} title={'Practices'} drug={''} />
        )}

        {statisticsData?.data && (
          <GeographicalStatistics
            GeographicalStatisticsListType={
              statisticsData?.data
                .geographical_stats as unknown as GeographicalStatisticsObject[]
            }
          />
        )}
        <FooterText footerType="black" />
      </div>
    </div>
  );
}
export default AllproductsAreaManager;